import { get, getPollsAxiosWithParams, post } from "helpers/api_helper"
import { all, call, put, race, take, takeEvery } from "redux-saga/effects"
import { showToast } from "utils"
import {
  displayDefaultReportsFailed,
  displayDefaultReportsSuccess,
  getActiveSiteUsersFailed,
  getActiveSiteUsersSuccess,
  getActiveUsersReportsFailed,
  getActiveUsersReportsSuccess,
  getAdReportsFailed,
  getAdReportsSuccess,
  getAllFeatureReportsFailed,
  getAllFeatureReportsSuccess,
  getAllUserResponsesFailed,
  getAllUserResponsesSuccess,
  getAppOpensMonthReportFailed,
  getAppOpensMonthReportSuccess,
  getAppOpensReportsFailed,
  getAppOpensReportsSuccess,
  getBookingPaymentReportsFailed,
  getBookingPaymentReportsSuccess,
  getDashboardSectionsFailed,
  getDashboardSectionsSuccess,
  getFeatureClicksFailed,
  getFeatureClicksSuccess,
  getFeatureResponsesByUserFailed,
  getFeatureResponsesByUserSuccess,
  getFeatureUsageReportFailed,
  getFeatureUsageReportSuccess,
  getFeatureViewsByUserFailed,
  getFeatureViewsByUserSuccess,
  getFormBuilderPaymentReportsFailed,
  getFormBuilderPaymentReportsSuccess,
  getFormListFailed,
  getFormListSuccess,
  getNewUsersReportsFailed,
  getNewUsersReportsSuccess,
  getRecentExperiencesFailed,
  getRecentExperiencesSuccess,
  getUserReportsFailed,
  getUserReportsSuccess,
  updateDashboardSectionsFailed,
  updateDashboardSectionsSuccess,
} from "./actions"
import * as url from "helpers/url_helper"
import {
  DISPLAY_DEFAULT_REPORTS,
  GET_ACTIVE_SITE_USERS,
  GET_ACTIVE_USERS_REPORTS,
  GET_AD_REPORTS,
  GET_ALL_FEATURE_REPORTS,
  GET_ALL_USER_RESPONSES,
  GET_APP_OPENS_MONTH_REPORT,
  GET_APP_OPENS_REPORTS,
  GET_BOOKING_PAYMENT_REPORTS,
  GET_DASHBOARD_SECTIONS,
  GET_FEATURE_CLICKS,
  GET_FEATURE_RESPONSES_BY_USER,
  GET_FEATURE_USAGE_REPORT,
  GET_FEATURE_VIEWS_BY_USER,
  GET_FORM_BUILDER_PAYMENT_REPORTS,
  GET_FORM_LIST,
  GET_NEW_USERS_REPORTS,
  GET_RECENT_EXPERIENCES,
  GET_USER_REPORTS,
  UPDATE_DASHBOARD_SECTIONS,
} from "./actionTypes"
import {
  getBasicContentList,
  getCommentBoardList,
  getCountdownClockList,
  getDocumentList,
  getEventInfoList,
  getFormBuilderList,
  getListOfLists,
  getMediaGalleryList,
  getPollList,
  getQuestionnaireList,
  getSurveyList,
  getTriviaChallengeList,
  getWebLinkList,
} from "store/actions"
import {
  GET_POLL_LIST_FAILED,
  GET_POLL_LIST_SUCCESS,
} from "store/menuFeatures/Poll/actionTypes"
import {
  GET_SURVEY_LIST_FAILED,
  GET_SURVEY_LIST_SUCCESS,
} from "store/menuFeatures/Survey/actionTypes"
import {
  GET_FORM_BUILDER_LIST_FAILED,
  GET_FORM_BUILDER_LIST_SUCCESS,
} from "store/menuFeatures/FormBuilder/actionTypes"
import {
  GET_TRIVIA_CHALLENGE_LIST_FAILED,
  GET_TRIVIA_CHALLENGE_LIST_SUCCESS,
} from "store/menuFeatures/TriviaChallenge/actionTypes"
import {
  GET_QUESTIONNAIRE_LIST_FAILED,
  GET_QUESTIONNAIRE_LIST_SUCCESS,
} from "store/menuFeatures/Questionnaire/actionTypes"
import {
  GET_EVENT_INFO_LIST_FAILED,
  GET_EVENT_INFO_LIST_SUCCESS,
} from "store/menuFeatures/EventInfo/actionTypes"
import {
  GET_WEB_LINK_LIST_FAILED,
  GET_WEB_LINK_LIST_SUCCESS,
} from "store/menuFeatures/WebLink/actionTypes"
import {
  GET_BASIC_CONTENT_LIST_FAILED,
  GET_BASIC_CONTENT_LIST_SUCCESS,
} from "store/menuFeatures/BasicContent/actionTypes"
import {
  GET_DOCUMENT_LIST_FAILED,
  GET_DOCUMENT_LIST_SUCCESS,
} from "store/menuFeatures/Document/actionTypes"
import {
  GET_COMMENT_BOARD_LIST_FAILED,
  GET_COMMENT_BOARD_LIST_SUCCESS,
} from "store/menuFeatures/CommentBoard/actionTypes"
import {
  GET_COUNTDOWN_CLOCK_LIST_FAILED,
  GET_COUNTDOWN_CLOCK_LIST_SUCCESS,
} from "store/menuFeatures/CountdownClock/actionTypes"
import {
  GET_MEDIA_GALLERY_LIST_FAILED,
  GET_MEDIA_GALLERY_LIST_SUCCESS,
} from "store/menuFeatures/MediaGallery/actionTypes"
import {
  GET_LIST_OF_LISTS_FAILED,
  GET_LIST_OF_LISTS_SUCCESS,
} from "store/menuFeatures/List/actionTypes"

function* getUserReports({ payload: params }) {
  try {
    const response = yield get(url.USER_REPORTS_URL, params)
    yield put(getUserReportsSuccess(response))
  } catch (error) {
    yield put(getUserReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getActiveUsersReports({ payload: params }) {
  try {
    const response = yield get(url.ACTIVE_USERS_REPORTS_URL, { params })
    yield put(getActiveUsersReportsSuccess(response))
  } catch (error) {
    yield put(getActiveUsersReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getNewUsersReports({ payload: params }) {
  try {
    const response = yield get(url.NEW_USERS_REPORTS_URL, { params })
    yield put(getNewUsersReportsSuccess(response))
  } catch (error) {
    yield put(getNewUsersReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getRecentExperiences({ payload: params }) {
  try {
    const response = yield get(url.RECENT_EVENTS_URL, params)
    yield put(getRecentExperiencesSuccess(response))
  } catch (error) {
    yield put(getRecentExperiencesFailed(error))
    showToast("error", error, "Error")
  }
}

function* getAdReports({ payload: params }) {
  try {
    const response = yield get(url.AD_REPORTS_URL, { params })
    yield put(getAdReportsSuccess(response))
  } catch (error) {
    yield put(getAdReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getBookingPaymentReports({ payload: params }) {
  try {
    const response = yield get(url.BOOKING_PAYMENTS_URL, { params })
    yield put(getBookingPaymentReportsSuccess(response))
  } catch (error) {
    yield put(getBookingPaymentReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getDashboardSections({ payload: params }) {
  try {
    const response = yield get(url.DASHBOARD_SECTIONS_URL, { params })
    yield put(getDashboardSectionsSuccess(response))
  } catch (error) {
    yield put(getDashboardSectionsFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateDashboardSections({ payload: params }) {
  try {
    const response = yield post(url.DASHBOARD_SECTIONS_URL, params)
    yield put(updateDashboardSectionsSuccess(params?.sections))
  } catch (error) {
    yield put(updateDashboardSectionsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getFeatureResponsesByUser({ payload: params }) {
  try {
    const response = yield get("feature/responsesByUser", { params })
    yield put(getFeatureResponsesByUserSuccess(response))
  } catch (error) {
    yield put(getFeatureResponsesByUserFailed(error))
    showToast("error", error, "Error")
  }
}

function* getAllUserResponses({ payload: params }) {
  try {
    const response = yield get("feature/responsesByUser", { params })
    yield put(getAllUserResponsesSuccess(response))
  } catch (error) {
    yield put(getAllUserResponsesFailed(error))
    showToast("error", error, "Error")
  }
}

function* getFeatureUsageReport({ payload: params }) {
  try {
    const response = yield get("/admin/reports/feature-usage", { params })
    yield put(getFeatureUsageReportSuccess(response))
  } catch (error) {
    yield put(getFeatureUsageReportFailed(error))
    showToast("error", error, "Error")
  }
}

function* getAppOpensReports({ payload: { id, ...params } }) {
  try {
    const response = yield get(`/admin/event/${id}/app-opens-reports`, {
      params,
    })
    yield put(getAppOpensReportsSuccess(response))
  } catch (error) {
    yield put(getAppOpensReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getAppOpensMonthReport({ payload: { id, ...params } }) {
  try {
    const response = yield get(`/admin/event/${id}/app-opens-reports`, {
      params,
    })
    yield put(getAppOpensMonthReportSuccess(response))
  } catch (error) {
    yield put(getAppOpensMonthReportFailed(error))
    showToast("error", error, "Error")
  }
}

function* getActiveSiteUsers({ payload: params }) {
  try {
    const response = yield get(`/admin/vendor/${params?.id}/active-site-users`)
    yield put(getActiveSiteUsersSuccess(response))
  } catch (error) {
    yield put(getActiveSiteUsersFailed(error))
    showToast("error", error, "Error")
  }
}

function* getFormBuilderPaymentReports({ payload: params }) {
  try {
    const response = yield get(url.FORM_BUILDER_PAYMENTS_URL, { params })
    yield put(getFormBuilderPaymentReportsSuccess(response))
  } catch (error) {
    yield put(getFormBuilderPaymentReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getFormList({ payload: params }) {
  try {
    const response = yield getPollsAxiosWithParams("/form-builder-list", {
      params,
    })
    yield put(getFormListSuccess(response))
  } catch (error) {
    yield put(getFormListFailed(error))
    showToast("error", error, "Error")
  }
}

function* getFeatureClicks({ payload: params }) {
  try {
    const response = yield get("/feature/clicks", { params })
    yield put(getFeatureClicksSuccess(response))
  } catch (error) {
    yield put(getFeatureClicksFailed(error))
    showToast("error", error, "Error")
  }
}

function* getFeatureViewsByUser({ payload: params }) {
  try {
    const response = yield get("/feature/viewsByUser", { params })
    yield put(getFeatureViewsByUserSuccess(response))
  } catch (error) {
    yield put(getFeatureViewsByUserFailed(error))
    showToast("error", error, "Error")
  }
}

function buildSections(
  newUsers,
  activeUsers,
  recentEvents,
  formBuilderPayments,
  bookingPayments,
  productPayments
) {
  const reports = []
  reports.push({ section: "session_report", order: 1 })
  reports.push({ section: "active_users", order: 2 })
  reports.push({ section: "device_report", order: 3 })
  if (newUsers?.length > 0 || activeUsers?.length > 0) {
    reports.push({ section: "users_report", order: 4 })
  }
  if (recentEvents?.length > 0) {
    reports.push({ section: "exp_report", order: 5 })
  }
  if (formBuilderPayments?.data?.length > 0) {
    reports.push({ section: "form_builder_transactions", order: 6 })
  }
  if (bookingPayments?.data?.length > 0) {
    reports.push({ section: "booking_transactions", order: 7 })
  }
  if (productPayments?.data?.length > 0) {
    reports.push({ section: "products_subscriprions_transactions", order: 8 })
  }
  return reports
}

const getWithErrorHandling = async (url, options) => {
  try {
    return await get(url, options)
  } catch (e) {
    console.error(e)
    return null
  }
}

function* displayDefaultReports({ payload: params }) {
  try {
    const {
      newUsers,
      activeUsers,
      recentEvents,
      formBuilderPayments,
      bookingPayments,
      productPayments,
    } = yield all({
      newUsers: call(getWithErrorHandling, url.NEW_USERS_REPORTS_URL, {
        params: { type: "year" },
      }),
      activeUsers: call(getWithErrorHandling, url.ACTIVE_USERS_REPORTS_URL, {
        params: { type: "year" },
      }),
      recentEvents: call(getWithErrorHandling, url.RECENT_EVENTS_URL, {}),
      formBuilderPayments: call(
        getWithErrorHandling,
        url.FORM_BUILDER_PAYMENTS_URL,
        {
          params: { o: "created_at", od: "desc", page: 1, per_page: 5 },
        }
      ),
      bookingPayments: call(getWithErrorHandling, url.BOOKING_PAYMENTS_URL, {
        params: { o: "created_at", od: "desc", page: 1, per_page: 5 },
      }),
      productPayments: call(getWithErrorHandling, url.ADMIN_ORDER_URL, {
        params: { o: "created_at", od: "desc", page: 1, per_page: 5 },
      }),
    })

    const sections = buildSections(
      newUsers,
      activeUsers,
      recentEvents,
      formBuilderPayments,
      bookingPayments,
      productPayments
    )

    yield call(updateDashboardSections, {
      payload: {
        sections: sections,
        user_id: params?.userId,
        vendor_id: params?.vendorId,
      },
    })

    yield put(displayDefaultReportsSuccess())
  } catch (error) {
    yield put(displayDefaultReportsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getAllFeaturesReports({ payload: params }) {
  try {
    const { event_id, per_page } = params
    const paramsData = {
      all: true,
      page: 1,
      per_page: per_page,
      event_id: event_id,
    }
    const features = [
      {
        action: getPollList,
        params: paramsData,
        success: GET_POLL_LIST_SUCCESS,
        fail: GET_POLL_LIST_FAILED,
      },
      {
        action: getSurveyList,
        params: paramsData,
        success: GET_SURVEY_LIST_SUCCESS,
        fail: GET_SURVEY_LIST_FAILED,
      },
      {
        action: getFormBuilderList,
        params: paramsData,
        success: GET_FORM_BUILDER_LIST_SUCCESS,
        fail: GET_FORM_BUILDER_LIST_FAILED,
      },
      {
        action: getTriviaChallengeList,
        params: paramsData,
        success: GET_TRIVIA_CHALLENGE_LIST_SUCCESS,
        fail: GET_TRIVIA_CHALLENGE_LIST_FAILED,
      },
      {
        action: getQuestionnaireList,
        params: paramsData,
        success: GET_QUESTIONNAIRE_LIST_SUCCESS,
        fail: GET_QUESTIONNAIRE_LIST_FAILED,
      },
      {
        action: getEventInfoList,
        params: paramsData,
        success: GET_EVENT_INFO_LIST_SUCCESS,
        fail: GET_EVENT_INFO_LIST_FAILED,
      },
      {
        action: getWebLinkList,
        params: paramsData,
        success: GET_WEB_LINK_LIST_SUCCESS,
        fail: GET_WEB_LINK_LIST_FAILED,
      },
      {
        action: getBasicContentList,
        params: paramsData,
        success: GET_BASIC_CONTENT_LIST_SUCCESS,
        fail: GET_BASIC_CONTENT_LIST_FAILED,
      },
      {
        action: getDocumentList,
        params: paramsData,
        success: GET_DOCUMENT_LIST_SUCCESS,
        fail: GET_DOCUMENT_LIST_FAILED,
      },
      {
        action: getCommentBoardList,
        params: {
          event_id: event_id,
          feature: "comment_board",
          page: 1,
          per_page: per_page,
        },
        success: GET_COMMENT_BOARD_LIST_SUCCESS,
        fail: GET_COMMENT_BOARD_LIST_FAILED,
      },
      {
        action: getCountdownClockList,
        params: paramsData,
        success: GET_COUNTDOWN_CLOCK_LIST_SUCCESS,
        fail: GET_COUNTDOWN_CLOCK_LIST_FAILED,
      },
      {
        action: getMediaGalleryList,
        params: {
          event_id: event_id,
          feature: "media",
          page: 1,
          per_page: per_page,
        },
        success: GET_MEDIA_GALLERY_LIST_SUCCESS,
        fail: GET_MEDIA_GALLERY_LIST_FAILED,
      },
      {
        action: getListOfLists,
        params: paramsData,
        success: GET_LIST_OF_LISTS_SUCCESS,
        fail: GET_LIST_OF_LISTS_FAILED,
      },
    ]

    for (const feature of features) {
      const { action, params } = feature
      yield put(action(params))
    }

    yield all(
      features.map(feature => {
        const { success, fail } = feature
        return race([take(success), take(fail)])
      })
    )

    yield put(getAllFeatureReportsSuccess())
  } catch (error) {
    yield put(getAllFeatureReportsFailed(error))
  }
}

function* analyticsSaga() {
  yield takeEvery(GET_USER_REPORTS, getUserReports)
  yield takeEvery(GET_ACTIVE_USERS_REPORTS, getActiveUsersReports)
  yield takeEvery(GET_NEW_USERS_REPORTS, getNewUsersReports)
  yield takeEvery(GET_RECENT_EXPERIENCES, getRecentExperiences)
  yield takeEvery(GET_AD_REPORTS, getAdReports)
  yield takeEvery(GET_BOOKING_PAYMENT_REPORTS, getBookingPaymentReports)
  yield takeEvery(GET_DASHBOARD_SECTIONS, getDashboardSections)
  yield takeEvery(UPDATE_DASHBOARD_SECTIONS, updateDashboardSections)
  yield takeEvery(GET_FEATURE_RESPONSES_BY_USER, getFeatureResponsesByUser)
  yield takeEvery(GET_FEATURE_USAGE_REPORT, getFeatureUsageReport)
  yield takeEvery(GET_APP_OPENS_REPORTS, getAppOpensReports)
  yield takeEvery(GET_ACTIVE_SITE_USERS, getActiveSiteUsers)
  yield takeEvery(GET_APP_OPENS_MONTH_REPORT, getAppOpensMonthReport)
  yield takeEvery(GET_ALL_USER_RESPONSES, getAllUserResponses)
  yield takeEvery(
    GET_FORM_BUILDER_PAYMENT_REPORTS,
    getFormBuilderPaymentReports
  )
  yield takeEvery(GET_FORM_LIST, getFormList)
  yield takeEvery(GET_FEATURE_CLICKS, getFeatureClicks)
  yield takeEvery(GET_FEATURE_VIEWS_BY_USER, getFeatureViewsByUser)
  yield takeEvery(DISPLAY_DEFAULT_REPORTS, displayDefaultReports)
  yield takeEvery(GET_ALL_FEATURE_REPORTS, getAllFeaturesReports)
}

export default analyticsSaga
